import { VideoRecord } from './VideoRecord';
export default VideoRecord;
